var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 1.91667C0.75 1.60725 0.872916 1.3105 1.09171 1.09171C1.3105 0.872916 1.60725 0.75 1.91667 0.75H3.83C3.95238 0.750093 4.07163 0.788673 4.17087 0.860279C4.27012 0.931885 4.34433 1.03289 4.383 1.149L5.25683 3.76992C5.30111 3.90311 5.29587 4.04781 5.24208 4.17746C5.1883 4.30711 5.08956 4.41301 4.964 4.47575L3.64742 5.13492C4.29277 6.56323 5.43677 7.70723 6.86508 8.35258L7.52425 7.036C7.58698 6.91044 7.69289 6.8117 7.82254 6.75792C7.95219 6.70413 8.09689 6.69889 8.23008 6.74317L10.851 7.617C10.9672 7.6557 11.0683 7.73 11.1399 7.82936C11.2115 7.92872 11.25 8.0481 11.25 8.17058V10.0833C11.25 10.3928 11.1271 10.6895 10.9083 10.9083C10.6895 11.1271 10.3928 11.25 10.0833 11.25H9.5C4.66767 11.25 0.75 7.33233 0.75 2.5V1.91667Z",
    fill: "white",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7619680f8d1eacb03c561f77341ae676.svg";
export { ForwardRef as ReactComponent };